<div class="login-wrapper">
  <!-- Section Visuelle (Gauche) -->
  <div class="login-visual">
    <div class="visual-content">
      <div class="brand">
        <div class="logo-container">
          <span class="logo-text lexend">alima</span>
          <span class="logo-subtext">by finappli</span>
        </div>
      </div>
      <div class="hero-text">
        <h1 class="lexend">Portail <br> d'administration.</h1>
        <p>Gérez vos institutions, utilisateurs et paramètres depuis une interface centralisée.</p>
      </div>
    </div>
    <div class="visual-footer">
      <span>&copy; Finappli SAS - {{ currentYear }}</span>
    </div>
  </div>

  <!-- Section Formulaire (Droite) -->
  <div class="login-form-section">
    <div class="login-card">
      <div class="form-container">
        @if (!requiresTwoFactor) {
          <div class="form-header">
            <h2 class="lexend">Bon retour !</h2>
            <p>Veuillez vous identifier pour acc&eacute;der &agrave; votre espace.</p>
          </div>

          <form [formGroup]="login" (submit)="onSubmit()" class="modern-form">
            <div class="form-field">
              <label for="username">Nom d'utilisateur</label>
              <div class="input-wrap">
                <i class="pi pi-user input-wrap__icon"></i>
                <input
                  pInputText
                  id="username"
                  placeholder="Entrez votre identifiant"
                  formControlName="username"
                  class="w-full modern-input" />
              </div>
            </div>

            <div class="form-field">
              <label for="password">Mot de passe</label>
              <div class="input-wrap">
                <i class="pi pi-lock input-wrap__icon"></i>
                <p-password
                  class="w-full modern-password"
                  [feedback]="false"
                  [toggleMask]="true"
                  formControlName="password"
                  id="password"
                  placeholder="Votre mot de passe"
                  [inputStyle]="{'width': '100%'}"
                  required>
                </p-password>
              </div>
            </div>

            <div class="form-actions">
              <a routerLink="/reset-password" class="forgot-password">Mot de passe oubli&eacute; ?</a>
            </div>

            <div class="button-container">
              <p-button
                class="w-full submit-btn"
                pRipple
                label="Se connecter"
                icon="pi pi-sign-in"
                iconPos="right"
                [disabled]="!login.valid"
                [loading]="isLoading"
                (onClick)="onSubmit()">
              </p-button>
            </div>
          </form>
        }

        @if (requiresTwoFactor) {
          <div class="form-header">
            <h2 class="lexend">V&eacute;rification</h2>
            <p>Un code de s&eacute;curit&eacute; est requis pour continuer</p>
          </div>

          <form [formGroup]="twoFactorForm" (submit)="onSubmitTwoFactor()" class="modern-form otp-form">
            <div class="otp-container">
              <p-inputOtp [integerOnly]="true" [length]="6" formControlName="code" />
            </div>

            <div class="button-container">
              <p-button
                class="w-full submit-btn"
                [loading]="isLoading"
                [disabled]="twoFactorForm.invalid"
                (onClick)="onSubmitTwoFactor()"
                label="V&eacute;rifier le code">
              </p-button>
            </div>

            <button type="button" class="back-btn" (click)="requiresTwoFactor = false">
              <i class="pi pi-arrow-left"></i> Retour &agrave; la connexion
            </button>
          </form>
        }
      </div>
    </div>
  </div>
</div>
